import { render } from "./ExtraInfo.vue?vue&type=template&id=7c64e83f&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=7c64e83f&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c64e83f"]])

export default __exports__